<script>
import ProfilePicker from '@/components/profile/ProfilePicker'
import ProfileTreeDetail from '@/components/profile/ProfileTreeDetail'
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  data() {
    return {
      selectedProfile: null,
      deleteConfirmation: false
    }
  },

  async created() {
    await this.$store.dispatch('fetchProfiles').then(profiles => {
      if (
        this.$route.name === 'profile-tree-detail' &&
        profiles &&
        profiles.length > 0
      ) {
        this.selectedProfile = profiles.find(profile => {
          return profile.hexId === this.$route.params.hexId
        }, this)
      }
    }, this)
  },

  computed: {
    ...mapState({
      items: state => {
        return state.profiles.profiles
      }
    }),
    ...mapGetters({
      can: 'can'
    })
  },

  watch: {
    selectedProfile() {
      this.routeEdit()
    }
  },

  methods: {
    routeEdit: function() {
      if (this.selectedProfile) {
        this.$router
          .replace({
            name: 'profile-tree-detail',
            params: { hexId: this.selectedProfile.hexId }
          })
          .catch()
      } else {
        this.$router.replace({ name: 'profile-tree-view' }).catch()
      }
    },
    createProfile: function() {
      this.$router.push({ name: 'profile-create' }).catch()
    },
    refreshProfile: function() {
      this.$store.dispatch('fetchProfiles')
    },

    async deleteConfirm() {
      try {
        if (this.selectedProfile != '') {
          await this.$store.dispatch(
            'deleteProfile',
            this.selectedProfile.hexId
          )
          await this.$store.dispatch('directNotification', {
            type: 'success',
            message: 'Profile deleted Successfully',
            description: `${this.selectedProfile.hexId} has been deleted Successfully`,
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
          this.selectedProfile = null
          await this.$store.dispatch('fetchProfiles')
        }
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Profile deletion Failed',
          description: e.response,
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.deleteConfirmation = false
    }
  },

  components: {
    ProfilePicker,
    ProfileTreeDetail
  }
}
</script>
<template>
  <v-card class="beez-card">
    <v-toolbar dense card class="elevation-2">
      <v-toolbar-title class="body-2 beez-bold ">Profiles</v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <v-btn slot="activator" icon @click.stop="refreshProfile">
          <v-icon>cached</v-icon>
        </v-btn>
        <span>Refresh</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn
          :outline="$vuetify.dark"
          slot="activator"
          icon
          :class="!$vuetify.dark ? 'secondary' : ''"
          :color="$vuetify.dark ? 'secondary' : ''"
          @click.stop="createProfile"
          v-if="can('PROFILES_CREATE')"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <span>Add</span>
      </v-tooltip>
      <v-dialog
        v-model="deleteConfirmation"
        persistent
        max-width="290"
        v-if="can('PROFILES_DELETE')"
      >
        <template slot="activator">
          <v-tooltip bottom>
            <v-btn v-show="selectedProfile" icon slot="activator">
              <v-icon>delete</v-icon>
            </v-btn>
            <span>Delete selected item</span>
          </v-tooltip>
        </template>
        <v-card>
          <v-card-title>
            Do you want to remove the item
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn icon flat @click="deleteConfirmation = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-btn icon flat class="primary" @click="deleteConfirm()">
              <v-icon>check</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <div
      v-if="!items.length"
      style="font-size:15px;text-align:left;"
      class="pa-4"
    >
      <v-icon style="font-size: 40px;" class="pr-2">sentiment_neutral</v-icon>
      Nothing to show. The list is empty.
    </div>
    <profile-picker v-model="selectedProfile" :items="items" v-else>
      <profile-tree-detail
        slot="picker-item-detail"
        slot-scope="slotProps"
        v-if="slotProps.item != null"
        :selected="slotProps.item"
      />
    </profile-picker>
  </v-card>
</template>
